import React from 'react';
import ScrollReveal from '../components/ScrollReveal';
import './LegalPage.css';
import SEO, { seoConfig } from '../components/SEO';

export default function PrivacyPolicy({ t }) {
  return (
    <div className="legal-page">
      <SEO
        title="Politique de confidentialité | Daniela Parito Architecture"
        description="Politique de confidentialité et protection des données personnelles du cabinet Daniela Parito Architecture."
        keywords="politique de confidentialité, données personnelles, RGPD, architecte montpellier"
        noindex
      />

      <div className="page-container">
        <ScrollReveal>
          <h1 className="page-title">Politique de Confidentialité</h1>
          <p className="page-subtitle">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
        </ScrollReveal>

        <div className="legal-content">
          <ScrollReveal delay={0.1}>
            <section className="legal-section">
              <h2 className="legal-section-title">1. Collecte des données</h2>
              <p>
                DP Architecture collecte des données personnelles uniquement lorsque vous nous contactez via le formulaire de contact du site. Les données collectées sont :
              </p>
              <ul>
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone (optionnel)</li>
                <li>Message et contenu de votre demande</li>
              </ul>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <section className="legal-section">
              <h2 className="legal-section-title">2. Utilisation des données</h2>
              <p>
                Les données collectées sont utilisées exclusivement pour :
              </p>
              <ul>
                <li>Répondre à vos demandes d'information</li>
                <li>Assurer le suivi de votre projet</li>
                <li>Vous envoyer des informations sur nos services (avec votre consentement)</li>
              </ul>
              <p>
                Vos données ne sont jamais vendues, louées ou partagées avec des tiers à des fins commerciales.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.3}>
            <section className="legal-section">
              <h2 className="legal-section-title">3. Durée de conservation</h2>
              <p>
                Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, et conformément aux obligations légales applicables.
              </p>
              <p>
                Les données de contact sont conservées pendant 3 ans maximum après notre dernier échange.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.4}>
            <section className="legal-section">
              <h2 className="legal-section-title">4. Vos droits</h2>
              <p>
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul>
                <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
                <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
                <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              </ul>
              <p>
                Pour exercer ces droits, contactez-nous à : <a href="mailto:daniela.parito@gmail.com" className="legal-link">daniela.parito@gmail.com</a>
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.5}>
            <section className="legal-section">
              <h2 className="legal-section-title">5. Cookies</h2>
              <p>
                Ce site n'utilise pas de cookies de tracking ou de publicité. Seuls des cookies techniques essentiels au fonctionnement du site peuvent être utilisés.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.6}>
            <section className="legal-section">
              <h2 className="legal-section-title">6. Sécurité</h2>
              <p>
                Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.7}>
            <section className="legal-section">
              <h2 className="legal-section-title">7. Contact</h2>
              <p>
                Pour toute question concernant cette politique de confidentialité, vous pouvez nous contacter :
              </p>
              <p>
                <strong>Email :</strong> <a href="mailto:daniela.parito@gmail.com" className="legal-link">daniela.parito@gmail.com</a><br />
                <strong>Téléphone :</strong> 06 14 90 25 13<br />
                <strong>Adresse :</strong> 663, rue du Pré aux Clercs - Le Fontenelle C3, 34090 MONTPELLIER
              </p>
            </section>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
}